import { render, staticRenderFns } from "./ProductsCarousel.vue?vue&type=template&id=333d8aaa&scoped=true&"
import script from "./ProductsCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCarousel.vue?vue&type=style&index=0&id=333d8aaa&scoped=true&lang=stylus&"
import style1 from "./ProductsCarousel.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333d8aaa",
  null
  
)

component.options.__file = "ProductsCarousel.vue"
export default component.exports